module.exports = __webpack_public_path__ + "static/media/edit.95fbdc6e.svg";